
import {
  computed,
  defineComponent,
  ref,
  type ComputedRef,
  type PropType,
} from "vue";
import ConnectProviderListItem from "@/modules/connect/components/ConnectProviderListItem.vue";
import { IProvider } from "@whitelabel-solutions/wallet-connector/";

export default defineComponent({
  props: {
    providers: {
      type: Array as PropType<IProvider[]>,
      default: () => [],
    },
  },
  emits: ["connect"],
  components: { ConnectProviderListItem },
  setup(props) {
    let providersCollapsed = ref(false);

    const providersVisible: ComputedRef<IProvider[]> = computed(() => {
      const p = props.providers;
      return p.slice(0, providersCollapsed.value ? p.length : 3);
    });

    return { providersCollapsed, providersVisible };
  },
});
